module.exports = __webpack_public_path__ + "static/media/DSC01811.7388660e.jpeg";